<div class="edit-flash-card" [class.fromCourse]="flashcardId">
  <form [formGroup]="form">
    <qa-content-spinner
      [active]="loading"
      [class.preventOverflow]="flashcardId"
    >
      <div class="content-flashcard">
        @if (showForm) {
        <div class="main-flex flex-row flex-auto-margin">
          @if (!showMobilePreview) {
          <mat-card appearance="outlined" [ngClass]="{ create: !courseId }">
            @if ( (!flashCard && !duplicateFlashCardId) || (flashCard &&
            duplicateFlashCardId) || (!flashCard && !form.value.id &&
            !questionId) ) {
            <div class="flashcard-header">
              @if (!flashCard && !duplicateFlashCardId) {
              <h1 class="create-title">
                {{
                  (form.value.id
                    ? 'flashCard.editTitle'
                    : questionId
                    ? 'common.button.convertToFlashCard'
                    : 'flashCard.addTitle'
                  ) | translate
                }}
              </h1>
              } @if (flashCard && duplicateFlashCardId) {
              <h1 class="create-title">
                {{ 'flashCard.duplicateFlashCardTitle' | translate }}
              </h1>
              } @if (!flashCard && !form.value.id && !questionId && !isImport) {
              <div class="template-select">
                <button
                  mat-button
                  (click)="$event.stopPropagation(); $event.preventDefault()"
                  [matMenuTriggerFor]="templateSelectMenu"
                >
                  {{ 'common.button.useTemplate' | translate
                  }}<mat-icon>play_circle</mat-icon>
                </button>
                <mat-menu #templateSelectMenu="matMenu">
                  @for (template of templates; track template.template) {
                  <button
                    mat-menu-item
                    (click)="useTemplate(template.template)"
                  >
                    {{ template.title }}
                  </button>
                  }
                </mat-menu>
              </div>
              }
            </div>
            } @if (questionId) {
            <p class="explanation">
              {{ 'common.message.conversionHint.flashCard' | translate }}
              <b>{{
                'common.message.conversionHint.flashCard2' | translate
              }}</b>
              {{ 'common.message.conversionHint.flashCard3' | translate }}
              <a
                target="_blank"
                href="https://quizacademy.de/tipps/content-konvertieren/"
              >
                {{ 'common.message.conversionHint.moreInfoLink' | translate }}.
              </a>
            </p>
            } @if (duplicateFlashCardId) {
            <p class="explanation">
              {{ 'common.message.duplicateHint.flashCard' | translate }}
            </p>
            }
            <ng-scrollbar>
              <div class="flash-card-form">
                <div class="preview">
                  @if (flashcardId) {
                  <qa-form-field-toggle
                    (valueChanged)="onValueChange($event)"
                    [label]="
                      'exam.users.accessRestriction.generateDialog.preview'
                        | translate
                    "
                  >
                  </qa-form-field-toggle>
                  }
                </div>
                <div class="attach-media">
                  @if ( !form?.value?.media.id &&
                  !form?.value?.youtube_link_question) {
                  <button
                    (click)="openDialog()"
                    class="attach-media-button"
                    color="primary"
                    mat-button
                    tabIndex="-1"
                    type="button"
                  >
                    <mat-icon class="material-icons">upload</mat-icon>
                    {{ 'flashCard.form.attachMedia' | translate }}
                  </button>
                  @if (form?.value?.media?.id) {
                  <div class="que-toggle">
                    <span
                      [class.active]="!form.value.video_question_or_answer"
                      >{{ 'common.label.question' | translate }}</span
                    >
                    <qa-form-field-toggle
                      [control]="form.get('video_question_or_answer')"
                    >
                    </qa-form-field-toggle>
                    <span
                      [class.active]="form.value.video_question_or_answer"
                      >{{ 'flashCard.form.answer' | translate }}</span
                    >
                    <mat-icon
                      class="info-tool-tip cursor-pointer"
                      (click)="openInfoDialog()"
                      >info</mat-icon
                    >
                  </div>
                  } } @else {
                  <div class="flex-row flex-align-items-end image-preview">
                    @if (!form?.value?.youtube_link_question) {
                    <div class="image-name flex-grow">
                      @if (form?.value?.media?.id) {
                      <img
                        src="{{ 'mediaUrl' | env }}/{{
                          form.value.media.uuid
                        }}.{{ form.value.media.file_ext }}"
                        class="image"
                      />
                      }
                    </div>
                    } @if (form?.value?.youtube_link_question) {
                    <div class="link flex-grow">
                      {{ form?.value?.youtube_link_question }}
                    </div>
                    }
                    <button
                      (click)="removeImage()"
                      [matTooltip]="'Löschen'"
                      mat-icon-button
                      tabindex="-1"
                      type="button"
                    >
                      <mat-icon class="material-icons image-upload-icon"
                        >delete_outline</mat-icon
                      >
                    </button>
                    @if (!form?.value?.youtube_link_question) {
                    <button
                      (click)="showImage()"
                      mat-icon-button
                      tabindex="-1"
                      type="button"
                    >
                      <mat-icon class="material-icons image-upload-icon"
                        >zoom_out_map</mat-icon
                      >
                    </button>
                    }
                  </div>
                  @if (form?.value?.media?.id) {
                  <div class="que-toggle question-answer-contents">
                    <span
                      [class.active]="!form.value.video_question_or_answer"
                      class="question-text"
                      >{{ 'common.label.question' | translate }}</span
                    >
                    <qa-form-field-toggle
                      [control]="form.get('video_question_or_answer')"
                    >
                    </qa-form-field-toggle>
                    <span
                      [class.active]="form.value.video_question_or_answer"
                      >{{ 'flashCard.form.answer' | translate }}</span
                    >
                    <mat-icon
                      class="info-tool-tip cursor-pointer info-icon"
                      (click)="openInfoDialog()"
                      >info</mat-icon
                    >
                  </div>
                  } }
                </div>
                <qa-form-field-input
                  [control]="form.get('text')"
                  [label]="'Text'"
                  [markdownHint]="true"
                  [multi]="true"
                  required="true"
                  data-cy="textField"
                >
                </qa-form-field-input>
                <qa-form-field-input
                  [control]="form.get('answer')"
                  label="{{ 'flashCard.form.answer' | translate }}"
                  [markdownHint]="true"
                  [multi]="true"
                  required="true"
                  data-cy="answerField"
                >
                </qa-form-field-input>
                <qa-form-field-input
                  [control]="form.get('explanation')"
                  label="{{ 'flashCard.form.explanation' | translate }}"
                  [markdownHint]="true"
                  [multi]="true"
                >
                </qa-form-field-input>
                <qa-form-field-input
                  [control]="form.get('weblink')"
                  [label]="'Weblink'"
                >
                </qa-form-field-input>
                <qa-form-field-input
                  [control]="form.get('source')"
                  label="{{ 'question.form.source' | translate }}"
                >
                </qa-form-field-input>
                @if (!loading) {
                <qa-tag-input
                  [control]="form.get('tags')"
                  label="{{ 'Tags' | translate }}"
                >
                </qa-tag-input>
                }
                <div
                  class="hint-text"
                  [innerHTML]="
                    'question.form.tagHint.questionsAndFlashcardsCategorized'
                      | translate
                  "
                ></div>
              </div>
            </ng-scrollbar>
          </mat-card>
          } @if (!flashcardId || (flashcardId && showMobilePreview)) {
          <div
            class="mock-phone-container"
            [class.showMobilePreview]="showMobilePreview"
          >
            @if (flashcardId) {
            <div class="preview mobile">
              <qa-form-field-toggle
                (valueChanged)="onValueChange($event)"
                [checked]="true"
                [label]="
                  'exam.users.accessRestriction.generateDialog.preview'
                    | translate
                "
              >
              </qa-form-field-toggle>
            </div>
            }
            <ng-scrollbar>
              @if (!loading) {
              <div class="mock-phone" [ngClass]="{ create: !courseId }">
                <qa-flash-card-mock-phone
                  [currentItemPosition]="currentItemIndex + 1"
                  [itemCount]="allFlashcards?.length"
                  [flashCard]="form.value"
                >
                </qa-flash-card-mock-phone>
              </div>
              }
            </ng-scrollbar>
            @if (!showMobilePreview) {
            <div
              class="flex-column flex-align-items-center flex-justify-content-center"
            >
              @if ( ((courseId || cardIdFromContent) && flashCard &&
              form.value.id) || isImport ) {
              <qa-import-csv-navigation
                [currentItemPosition]="currentItemIndex + 1"
                [disabledNavigation]="form.invalid"
                [itemCount]="
                  isImport ? importNavigation?.count : allFlashcards?.length
                "
                (navigation)="
                  isImport ? importNavigate.emit($event) : onNavigate($event)
                "
                [isImport]="isImport"
              >
              </qa-import-csv-navigation>
              }
            </div>
            }
          </div>
          }
        </div>
        }
      </div>
    </qa-content-spinner>
    @if (!loading) {
    <div class="actions">
      <ng-content select="[actionButtons]">
        <ng-container *ngTemplateOutlet="actions"></ng-container>
      </ng-content>
    </div>
    }

    <ng-template #actions>
      <div class="action-container">
        <div class="left-actions">
          @if (!flashcardId) { @if (flashCard && !duplicateFlashCardId) {
          <qa-button
            label="common.button.duplicate"
            (submitted)="duplicatedFlashCard()"
          ></qa-button>
          } @if (id && flashCard?.accepted) {
          <qa-button
            label="common.button.convertToQuestion"
            (submitted)="convertToQuestion()"
          ></qa-button>
          } } @if (id) {
          <qa-button
            [matMenuTriggerFor]="moreMenu"
            [isIconButton]="true"
            icon="more_vert"
          ></qa-button>
          }
          <mat-menu
            class="material-menu"
            [overlapTrigger]="true"
            #moreMenu="matMenu"
          >
            @if (flashcardId) { @if (flashCard && !duplicateFlashCardId) {
            <button (click)="duplicatedFlashCard()" mat-menu-item type="button">
              <mat-icon>copy</mat-icon>
              {{ 'common.button.duplicate' | translate }}
            </button>
            } @if (id && flashCard?.accepted) {
            <button (click)="convertToQuestion()" mat-menu-item type="button">
              <mat-icon>crop</mat-icon>
              {{ 'common.button.convertToQuestion' | translate }}
            </button>
            } } @if (hasComments) {
            <button (click)="showComments()" mat-menu-item type="button">
              <mat-icon>comment</mat-icon>
              {{ 'comment.label.showComment' | translate }}
            </button>
            }
            <button (click)="exportAsJson()" mat-menu-item type="button">
              <mat-icon>download</mat-icon>
              {{ 'content.course.actionMenu.downloadJSON' | translate }}
            </button>
            @if (form.value.id) {
            <button (click)="onDelete()" mat-menu-item type="button">
              <mat-icon>delete</mat-icon>
              {{ 'common.button.clear' | translate }}
            </button>
            }
          </mat-menu>
        </div>
        <div class="flex-align-right">
          <qa-button
            data-cy="close"
            label="common.button.shutdown"
            (submitted)="onClose()"
          ></qa-button>
          @if (flashCard || questionId) { @if ( (flashCard &&
          flashCard?.accepted && userId === flashCard?.created_by) || !flashCard
          ) {
          <qa-button
            [disabled]="form.invalid || form.pristine"
            [isRaisedButton]="true"
            label="common.button.save"
            (submitted)="onSubmit()"
            data-cy="save"
          ></qa-button>
          } } @if (flashCard && !flashCard?.accepted) {
          <qa-button
            [disabled]="form.invalid || form.pristine"
            [isRaisedButton]="true"
            label="{{
              flashCardStackId
                ? 'common.button.saveWithoutAddToStack'
                : 'common.button.save'
            }}"
            (submitted)="onSubmit()"
          ></qa-button>
          } @if (id && !flashCard?.accepted) {
          <qa-button
            [disabled]="form.invalid"
            [isRaisedButton]="true"
            label="{{
              flashCardStackId
                ? 'common.button.addFlashCardToStack'
                : 'common.button.acceptFlashCard'
            }}"
            (submitted)="addFlashCardToStack()"
          ></qa-button>
          } @if (!flashCard && !questionId) {
          <qa-button
            #addButton
            [matMenuTriggerFor]="addMenu"
            [disabled]="form.invalid || form.pristine"
            [isRaisedButton]="true"
            label="common.button.save"
            data-cy="save"
          ></qa-button>
          }
          <mat-menu
            class="material-menu"
            [overlapTrigger]="true"
            #addMenu="matMenu"
          >
            @if (!flashcardId) { @if (!form.value.id && !duplicateFlashCardId &&
            !questionId) {
            <button
              (click)="onSubmit(true)"
              [disabled]="form.invalid || form.pristine"
              mat-menu-item
              type="button"
            >
              <mat-icon>add</mat-icon>
              {{ 'common.button.saveAndNew' | translate }}
            </button>
            } @if (!form.value.id && !duplicateFlashCardId && !questionId) {
            <button
              (click)="onSubmit(true, true)"
              [disabled]="form.invalid || form.pristine"
              mat-menu-item
              type="button"
            >
              <mat-icon>copy</mat-icon>
              {{ 'common.button.saveAndDuplicate' | translate }}
            </button>
            } } @if ( (flashCard && flashCard?.accepted && userId ===
            flashCard?.created_by) || !flashCard ) {
            <button
              [disabled]="form.invalid || form.pristine"
              (click)="onSubmit()"
              mat-menu-item
              type="button"
              data-cy="saveAndClose"
            >
              <mat-icon>check</mat-icon>
              {{ 'common.button.saveAndClose' | translate }}
            </button>
            } @if (flashCard && userId !== flashCard?.created_by) {
            <button
              [disabled]="form.invalid || form.pristine"
              matTooltipClass="preline"
              matTooltip="{{ 'flashCard.form.unlinkSaveTooltip' | translate }}"
              (click)="unlinkCard()"
              mat-menu-item
              type="button"
            >
              <mat-icon class="material-icons">shopping_cart</mat-icon>
              {{ 'question.form.unlinkSave' | translate }}
            </button>
            }
          </mat-menu>
        </div>
      </div>
    </ng-template>
  </form>
</div>
